import PropTypes from "prop-types";
import {Animated, Dimensions, Easing, Image, PanResponder, Pressable, StyleSheet, View} from "react-native";
import React, {useContext, useEffect, useRef, useState} from "react";
import MainHeader from "../assets/MainHeader";
import Text from "./Text";
import {Colors} from "../colors";
import AppConfigContext from "../../../contexts/AppConfigContext";
import {MenuDetails} from "../../../rest/jtmc/models/MenuDetails";
import TableNumberBackground from "../assets/TableNumberBackground";
import CategoryIndicator from "../assets/CategoryIndicator";
import {navigate} from "../../../refrences/RootNavigation";
import ThemeContext from "@react-navigation/native/lib/typescript/src/theming/ThemeContext";

type Position = { x: number, y: number };

const spinnerSoundEffect = require("../assets/spin-sound-effects/tik.mp3");

// Should be more than 1
const size = 6.4;
const itemWidth = 52;
const itemMargin = 1.4;
export const headerHeight = 70;

export function HeaderComponents(props: { menuDetails: MenuDetails }) {
    const blinkingAnimation = useRef(new Animated.Value(1)).current;
    const colors = Colors.instance(useContext(AppConfigContext).theme, useContext(AppConfigContext).color);
    const TableNumberView = () => {
        return useContext(AppConfigContext).orderType == "table" ?
            <View style={{height: 25, width: 115, paddingBottom: 2, justifyContent: "center", alignItems: "center"}}>
                <TableNumberBackground/>
                <View style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <Text size={10} color={"white"}
                          weight={600}>{`شماره میز شما: ${props.menuDetails.tableNumber}`}</Text>
                </View>
            </View> : <></>;
    }

    useEffect(()=>{

        Animated.loop(
            Animated.sequence([
                Animated.timing(blinkingAnimation, {
                    toValue: 0,
                    duration: 300,
                    delay: 600,
                    useNativeDriver: false
                }),
                Animated.timing(blinkingAnimation, {
                    toValue: 1,
                    duration: 300,
                    useNativeDriver: false
                })
            ])
        ).start()

    }, []);

    return <View style={{justifyContent: "center", alignItems: "center", height: 71}}>
        <View style={{flexDirection: "row", flexGrow: 1, padding: 6, flex: 1, width: "100%", maxWidth: 570}}>
            <Pressable onPress={() => navigate("BranchInfoScreen", {
                branchInfo: props.menuDetails?.branchInfo
            })} style={{flexGrow: 1, flexBasis: 1, justifyContent: "center", alignItems: "center"}}>
                <Text color={"#fff"} size={13} weight={700}>{props.menuDetails.branchInfo.storeName}</Text>
                <Text color={"#fff"} size={10} weight={600}>(مشاهده اطلاعات مجموعه)</Text>
            </Pressable>
            <Pressable onPress={() => navigate("BranchInfoScreen", {
                    branchInfo: props.menuDetails?.branchInfo
                })}>
                <Image resizeMode={"contain"} style={{width: 80, height: "100%"}}
                       source={{uri: props.menuDetails.branchInfo.logoUrl}}/>
            </Pressable>
            <Pressable onPress={()=>{
                navigate("BranchWorkingTime", {
                    branchInfo: props.menuDetails?.branchInfo
                });
            }} style={{flexGrow: 1, flexBasis: 1, justifyContent: "center", alignItems: "center"}}>
                {props.menuDetails.branchInfo.isInActiveTime ?

                    <Animated.View style={{justifyContent: "center", alignItems: "center", opacity: blinkingAnimation}}>

                        <Text style={{
                            paddingHorizontal: 8, paddingVertical: 2, backgroundColor: colors.get("green") as string,
                            borderRadius: 8
                        }} color={"#fff"} size={11} weight={700}>آماده پذیرش سفارش</Text>

                    </Animated.View>

                     :
                    <View style={{justifyContent: "center", alignItems: "center"}}>
                        <Animated.View style={{justifyContent: "center", alignItems: "center", opacity: blinkingAnimation}}>
                            <Text style={{
                                paddingHorizontal: 8, paddingVertical: 2, backgroundColor: "#f00",
                                borderRadius: 8
                            }} color={"#fff"} size={12} weight={700}>تعطیل</Text>
                        </Animated.View>
                        <Text color={"#fff"} size={10} weight={600}>(مشاهده ساعت فعالیت)</Text>
                    </View>
                }
            </Pressable>
        </View>
        <TableNumberView/>
    </View>;
}

function CircleSpinner(props: { menuDetails: MenuDetails | undefined }) {
    const menuDetails: MenuDetails | undefined = props.menuDetails;
    return menuDetails != null ?
        <CircleSpinnerInstance {...props} items={menuDetails.menuItems.map((item) => item.category)}>
            <HeaderComponents menuDetails={menuDetails}/>
        </CircleSpinnerInstance> : <></>
}

let selectedItemNumber = 0;

function CircleSpinnerInstance(props: any) {

    const [items, setItems] = useState<any[]>([])
    const colors = Colors.instance(useContext(AppConfigContext).theme, useContext(AppConfigContext).color);
    const [initiationScrollFired, setInitiationScrollFired] = useState(false);

    // Animating

    const windowWidth = Dimensions.get('window').width;
    const halfScreenWidth = windowWidth / 2;

    const [circleWidth, setCircleWidth] = useState(0);
    const [circleArea, setCircleArea] = useState(0);
    const [itemCoordinates, setItemCoordinates] = useState<{ x: number, y: number, a: number }[]>([]);
    const [circleCoordinates, setCircleCoordinates] = useState<Position>({x: 0, y: 0});
    const [circleItemsCount, setCircleItemsCount] = useState(0);

    const [spinnerRound, setSpinnerRound] = useState(0);

    const [visibleItemsCount, setVisibleItemsCount] = useState(0);

    const [textsOffset, setTextOffset] = useState(0);

    const radius = circleWidth / 2;

    const circle = useRef<View>(null);

    const pan = useRef(new Animated.ValueXY()).current;

    const onItemChange = (item: any, number: number) => {
        if (number == selectedItemNumber)
            return;
        selectedItemNumber = number;
        props.onItemChange(items[number], number);
        const audio = new Audio(spinnerSoundEffect);
        audio.play();
    }

    const panResponder = React.useMemo(() =>
        PanResponder.create({
            onMoveShouldSetPanResponder: () => true,
            onPanResponderGrant: () => {
                pan.setOffset({
                    // @ts-ignore
                    x: pan.x._value,
                    // @ts-ignore
                    y: pan.y._value
                });
            },
            onPanResponderStart: () => {
            },
            onPanResponderMove: (evt, gestureState) => {
                const {dx, dy} = gestureState;
                pan.x.setValue(dx);
                pan.y.setValue(dy);
                const scroll = Math.round(pan.x.interpolate({
                    inputRange: [-windowWidth * spinSpeed, windowWidth * spinSpeed],
                    outputRange: [-circleArea + textsOffset, circleArea + textsOffset]
                    //@ts-ignore
                }).__getValue());
                const unitsMoved = Math.floor(scroll / circleArea);
                setSpinnerRound(unitsMoved);

                const index = Math.floor((scroll + halfScreenWidth) / (circleArea / (circleItemsCount)));
                const number = ((index % circleItemsCount) + circleItemsCount) % circleItemsCount;
                onItemChange(items[number], number);
            },
            onPanResponderEnd: (evt, gestureState) => {
                const {vx, dx} = gestureState;
                // Todo: Test Harder
                if (Math.abs(vx) < .5)
                    pan.flattenOffset();
                else
                    Animated.timing(pan.x, {
                        toValue: dx * Math.min(Math.abs(vx), 3),
                        easing: Easing.out(Easing.exp),
                        useNativeDriver: false
                    }).start(e => {
                        pan.flattenOffset();
                        const scroll = Math.round(pan.x.interpolate({
                            inputRange: [-windowWidth * spinSpeed, windowWidth * spinSpeed],
                            outputRange: [-circleArea + textsOffset, circleArea + textsOffset]
                            //@ts-ignore
                        }).__getValue());
                        const index = Math.floor((scroll + halfScreenWidth) / (circleArea / (circleItemsCount)));
                        const number = ((index % circleItemsCount) + circleItemsCount) % circleItemsCount;
                        onItemChange(items[number], number);
                    });
            }
        }), [circleArea]);

    useEffect(() => {
        // Setup containers
        const circleArea = circleWidth * 3.14;
        const allItemsCount = Math.round(circleArea / itemWidth / itemMargin);
        const itemCoordinates: { x: number, y: number, a: number }[] = [];
        const radius = circleWidth / 2;
        const delta = 360 / allItemsCount;
        const cx = -radius + (itemWidth / 2);
        const cy = radius - (itemWidth / 2);

        for (let index = 0; index < allItemsCount; index++) {
            let angle = delta * index + 90;
            let radians = angle * 3.14 / 180;
            let x = cx + radius * Math.cos(radians);
            let y = cy + radius * Math.sin(radians);
            itemCoordinates.push({
                x: x, y: y, a: angle
            });
        }

        const visibleArc = calculateArcLength(windowWidth, radius);

        setVisibleItemsCount(visibleArc / itemWidth / itemMargin)
        setCircleArea(circleArea);
        setCircleItemsCount(allItemsCount);
        setItemCoordinates(itemCoordinates);
        setTextOffset(-halfScreenWidth + (itemWidth / 2) + ((itemWidth - itemWidth / itemMargin) / 2));
        const filledArray = [];
        for (let i = 0; i < allItemsCount; i++) {
            const inputItemIndex = i % props.items.length;
            filledArray.push(props.items[inputItemIndex]);
        }
        setItems(filledArray);

    }, [circleWidth, circleCoordinates, windowWidth]);

    useEffect(() => {
        if (items.length == 0)
            return;
        if (initiationScrollFired)
            return;
        setTimeout(() => {
            onPressItem(Math.round(items.length / 4));
        }, 500);
        setInitiationScrollFired(true);
    }, [items]);

    const onPressItem = (index: number) => {
        const units = index - selectedItemNumber;
        const toMove = units * 46.2;
        // @ts-ignore
        const moveTo = pan.x._value + toMove;
        Animated.spring(pan.x, {
            toValue: moveTo,
            useNativeDriver: false
        }).start();
        onItemChange(items[index], index);
    }

    const itemsToShow = React.useMemo(() => {
        return itemCoordinates.map((item, index) => {
            return <SpinnerItem angleFromCenter={item.a}
                                key={index}
                                index={index}
                                onPress={onPressItem}
                                coordinate={item}
                                data={items[index]}/>
        })
    }, [itemCoordinates]);

    const spinSpeed = size * 2;

    const rotation = pan.x.interpolate({
        inputRange: [-windowWidth * spinSpeed, windowWidth * spinSpeed],
        outputRange: [`360deg`, `-360deg`],
    });
    const move = pan.x.interpolate({
        inputRange: [-windowWidth * spinSpeed, windowWidth * spinSpeed],
        outputRange: [-circleArea + textsOffset, circleArea + textsOffset]
    });

    // todo: optimize using useMemo
    // Todo: solve margin problem
    // Todo: ending anim. DONE, NEEDS TEST
    // todo: resizing. LOOKS OK
    // todo: extract repeated variables
    // todo: item setting :,). UPDATE: DONE BUT CANT HANDLE MORE THAT ITS CAPACITY

    const texts = React.useMemo(() => {
        return items.map((item, index) => {
            return <Text size={11} weight={600} key={index}
                         style={{width: itemWidth * itemMargin, textAlign: "center"}}>{item.name}</Text>
        });
    }, [items]);

    // Todo: gradiant the background
    return <View {...panResponder.panHandlers} style={{backgroundColor: colors.get("transparentBackgroundHighlight") as string}}>

        <Pressable style={{height: headerHeight, width: "100%"}}>
            <MainHeader height={headerHeight}/>
        </Pressable>

        <CategoryIndicator style={{
            width: 12, height: 5,
            position: "absolute",
            top: headerHeight + 2,
            alignSelf: "center"
        }}/>

        {/*final transform here*/}
        <View style={{
            transform: [
                {translateY: -(radius - (itemWidth * .8))}
            ]
        }}>
            {/*rotate this*/}
            <Animated.View style={{
                transform: [
                    {rotate: rotation}
                ]
            }}>
                {/*adjust this*/}
                <View style={{
                    transform: [
                        {translateX: -halfScreenWidth + radius},
                        {translateY: -radius}
                    ]
                }}>
                    <View style={{
                        position: "absolute",
                        width: (size * 100) + "%",
                        height: circleWidth,
                        borderRadius: radius,
                    }} ref={circle}
                          onLayout={(event) => {
                              setCircleCoordinates({x: event.nativeEvent.layout.x, y: event.nativeEvent.layout.y})
                              setCircleWidth(event.nativeEvent.layout.width);
                          }}/>
                    {itemsToShow}
                </View>
            </Animated.View>
        </View>
        <View style={{overflow: "visible", marginTop: 75}}>
            <Animated.View style={{
                width: circleArea,
                height: 30,
                justifyContent: "center",
                flexDirection: "row",
                transform: [
                    {
                        translateX: move
                    }
                ]
            }}>
                <TextShifter ca={circleArea} texts={texts} round={spinnerRound}/>
            </Animated.View>
        </View>
        <View style={{position: "absolute", width: "100%", height: headerHeight}}>
            {props.children}
        </View>
    </View>
}

function TextShifter(props: any) {

    const [x, setX] = useState(0);

    useEffect(() => {
        setX(-(props.ca * props.round))
    }, [props.round]);

    return <View style={{transform: [{translateX: x}], flexDirection: "row"}}>
        <View style={{
            paddingLeft: 4,
            width: props.ca, flexDirection: "row", justifyContent: "space-around", transform: [{
                translateX: itemMargin * 2
            }]
        }}>
            {props.texts}
        </View>
        <View style={{
            paddingLeft: 4,
            width: props.ca, flexDirection: "row", justifyContent: "space-around", transform: [{
                translateX: itemMargin * 2
            }]
        }}>
            {props.texts}
        </View>
        <View style={{
            paddingLeft: 4,
            width: props.ca, flexDirection: "row", justifyContent: "space-around", transform: [{
                translateX: itemMargin * 2
            }]
        }}>
            {props.texts}
        </View>
    </View>
}

const SpinnerItem = React.memo((props: any) => {
    const styles = lStyles(Colors.instance(useContext(AppConfigContext).theme, useContext(AppConfigContext).color));
    return <Pressable onPress={() => props.onPress(props.index)} style={[styles.itemContainer, {
        transform: [{translateX: props.coordinate.x}, {translateY: props.coordinate.y}]
    }]}>
        <View style={styles.imageContainer}>
            <HeadStrongImage angleFromCenter={props.angleFromCenter}
                             style={styles.image}
                             source={props.data.logo}/>
        </View>
    </Pressable>
});

const HeadStrongImage = (props: any) => {
    const rotation = props.angleFromCenter - 90;
    return <Image {...props} style={[props.style, {
        transform: [{
            rotate: `${rotation}deg`
        }]
    }]}/>
}

CircleSpinner.propTypes = {
    size: PropTypes.number,
    onSpin: PropTypes.func,
    onCircleCreated: PropTypes.func,
    onItemChange: PropTypes.func,
    children: PropTypes.any
};

function calculateArcLength(distance: number, radius: number): number {
    const l = 2 * radius * Math.asin(distance / (2 * radius));
    if (Number.isNaN(l))
        return 0;
    return l;
}

const lStyles = (colors: Colors) => StyleSheet.create({
    handlerCircle: {
        position: "absolute"
    },
    itemContainer: {
        position: "absolute",
        width: itemWidth,
        alignItems: "center"
    },
    imageContainer: {
        width: itemWidth, height: itemWidth,
        borderColor: colors.get("separator") as string, borderWidth: 1.5, borderRadius: 50,
        justifyContent: "center",
        alignItems: "center"
    },
    image: {
        width: 29,
        height: 29
    }
});


export default CircleSpinner;